import { type PropsWithChildren } from "react";
import { Drawer, type DrawerProps } from "@mui/material";

const slotProps: DrawerProps["slotProps"] = {
  paper: {
    ref: (node: HTMLDivElement) => {
      const observer = new ResizeObserver(([entry]) => {
        document.body.style.setProperty(
          "--drawer-height",
          `${entry.target.getBoundingClientRect().height}px`,
        );
      });

      observer.observe(node);

      return () => {
        observer.disconnect();
        document.body.style.setProperty("--drawer-height", "0");
      };
    },
  },
};

export const PersistentDrawer = ({
  children,
  ...props
}: PropsWithChildren<DrawerProps>) => {
  return (
    <Drawer
      slotProps={slotProps}
      anchor="bottom"
      variant="persistent"
      open
      {...props}
    >
      <div className="w-full">{children}</div>
    </Drawer>
  );
};
